import cloudLoginPageUploadImageRedux from 'Modules/loginPage/main/.components/uploadImage/redux/reducer';
import createEditTemplateRedux from 'Modules/loginPage/main/.components/createEditTemplate/redux/reducer';
import loginPageMainRedux from 'Modules/loginPage/main/redux/reducer';
//export redux objects
export default {
	cloudLoginPageUploadImageRedux,
	createEditTemplateRedux,
	loginPageMainRedux,
};